import * as React from 'react'

import OptionsPopoverShell, {
  IOptionsPopoverShellProps,
} from '~/client/src/shared/components/OptionsList/shells/OptionsPopoverShell'

import { IViewOptionsPanelProps } from './types'
import ViewOptionsPanel from './ViewOptionsPanel'
import ViewOptionsTrigger from './ViewOptionsTrigger'

interface IProps extends IViewOptionsPanelProps {
  open?: boolean
  onOpenChange?: (open: boolean) => void
  trigger?: React.ReactNode
  side?: 'top' | 'bottom' | 'left' | 'right'
  align?: 'start' | 'center' | 'end'
  contentClassName?: string
  portalContainer?: IOptionsPopoverShellProps['portalContainer']
}

const ViewOptionsPopover: React.FC<IProps> = ({
  open,
  onOpenChange,
  trigger,
  side = 'bottom',
  align = 'start',
  contentClassName,
  portalContainer,
  grouping,
  sorting,
  columns,
}) => {
  const [internalOpen, setInternalOpen] = React.useState(false)
  const actualOpen = open ?? internalOpen
  const handleOpenChange = React.useCallback(
    (nextOpen: boolean) => {
      setInternalOpen(nextOpen)
      onOpenChange?.(nextOpen)
    },
    [onOpenChange],
  )

  return (
    <OptionsPopoverShell
      open={actualOpen}
      onOpenChange={handleOpenChange}
      trigger={trigger ?? <ViewOptionsTrigger />}
      portalContainer={portalContainer}
      side={side}
      align={align}
      contentClassName={contentClassName ?? 'tw:overflow-hidden'}
    >
      <ViewOptionsPanel
        grouping={grouping}
        sorting={sorting}
        columns={columns}
        onClose={() => handleOpenChange(false)}
      />
    </OptionsPopoverShell>
  )
}

export default ViewOptionsPopover
